export default __webpack_public_path__ + "static/countdown_open-184727cf104b67643c013cc49729e894.png";